import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Reviews.module.css';

const reviews = [
  {
    text: "I spent 11 days in Phuket staying in Kathu. To move around to the beach, restaurants and visit the island I needed a motorbike and next to my hotel I found Bird Motorbike — reliable and friendly with good service. If I'm around this area again I will rent here. Guaranteed cash deposit and good daily price.",
    name: 'Adri E.',
    time: 'a week ago',
  },
  {
    text: "I've been travelling for about 10 years and been through 100's of bike rentals. I have to say that the customer service and professionalism of this shop is hands down top tier level. The pricing, safety of the bikes and the variety and cleanliness of the helmets was top tier. I would definitely recommend to rent from this shop!",
    name: 'Seegu T.',
    time: 'a month ago',
  },
  {
    text: "Bird Motorbike is a great help, very affordable, and the motorbikes are in pretty good condition. They make everything easy and straightforward, especially if you barely speak English or Thai. I had no problems with them, and even when my motorbike stand broke, they didn't charge me anything. I'll definitely use them again when I return to Thailand!",
    name: 'Victor M.',
    time: 'a month ago',
  },
  {
    text: 'I rented a scooter from Bird Motorbike while staying in Phuket and it was one of the best decisions of my trip. The booking process was simple, the staff were professional and helpful. Highly recommend!',
    name: 'Javokhir N.',
    time: '2 months ago',
  },
  {
    text: "Great bike (125cc) for my needs. I rented a new machine that was working flawlessly, engine was smooth, no scratches. Such professional conduct from Bird and a warm, welcoming smile. I recommend this shop to everyone who wants a good machine and a great experience. This is your place to get your bike from!",
    name: 'Tomasz S.',
    time: '3 months ago',
  },
];

function Reviews() {
  const { t } = useTranslation();
  return (
    <section id="reviews" className={styles.section}>
      <h2 className={styles.heading}>{t('reviews.heading')}</h2>
      <div className={styles.rating}>
        <span className={styles['rating-stars']}>★★★★★</span>
        <span className={styles['rating-score']}>4.8</span>
        <span className={styles['rating-label']}>{t('reviews.onGoogle')}</span>
      </div>
      <p className={styles.subheading}>{t('reviews.subheading')}</p>
      <div className={styles.grid}>
        {reviews.map((review, i) => (
          <article key={i} className={styles.card}>
            <div className={styles['stars-row']}>
              <span className={styles.stars}>★★★★★</span>
              <span className={styles.time}>{review.time}</span>
            </div>
            <p className={styles.text}>{review.text}</p>
            <div className={styles.author}>
              <div className={styles.avatar}>{review.name.charAt(0)}</div>
              <strong>{review.name}</strong>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Reviews;
